import React from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import './sidenavitem.scss';

const SideNavItemChild = ({ menuItem }) => {
  const location = useLocation();
  const isActive = () => {
    return location.pathname === menuItem.url;
  };
  const isExternal = menuItem.url && menuItem.url.startsWith('http');
  const content = (
    <div className={`side-nav-item m-auto d-flex align-items-center px-4 ${isActive() ? 'active' : ''} ${menuItem.customClass || ''}`}>
      <i className={`fa ${menuItem.iconClass}`}></i>
      <span className="text-nowrap">{menuItem.title}</span>
    </div>
  );

  if (isExternal) {
    return (
      <a href={menuItem.url} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
        {content}
      </a>
    );
  }

  return (
    <Link to={menuItem.url} onClick={event => (menuItem.onClick && menuItem.onClick(event))} className="text-decoration-none">
      {content}
    </Link>
  );
};

export default SideNavItemChild;
